export default (theme) => ({
    overlay: {},
    content: {},
    body: {
        padding: '0 8px',
    },
    markdown: {
        wordWrap: 'break-word',
        '& strong': {
            fontWeight: 500,
        },
        '& em': {
            fontStyle: 'italic',
        },
        '& li, & ol, & ul': {
            listStyle: 'initial',
            paddingLeft: 16,
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            margin: 0,
        },
        '& code': {
            backgroundColor: theme.colors.grey?.[100],
            borderRadius: 4,
            padding: '0 4px',
        },
        '& pre': {
            backgroundColor: theme.colors.grey?.[100],
            borderRadius: 4,
            padding: 8,
            overflowX: 'auto',
        },
        '& hr': {
            border: 'none',
            borderTop: `1px solid ${theme.colors.grey?.[100]}`,
            margin: 0,
        },
    },
    loading: {
        padding: 24,
        display: 'flex',
        justifyContent: 'center',
    },
    error: {
        padding: 24,
        textAlign: 'center',
    },
});
